import { useDispatch } from "react-redux";

import { useMount } from "app/custom-hooks/useMount";

import { getDynamicsStatusThunk } from "../../store/effects/dynamics/status";

const useDynamicsStatusCall = (): void => {
    const dispatch = useDispatch();

    useMount(() => {
        void dispatch(getDynamicsStatusThunk());
    });
};

export default useDynamicsStatusCall;
